import { Comunidad } from '../../../../src/app/shared/model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs/rx';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { GenericResponse, SearchEmpleadoAsistenciaExport, SearchEmpleadoAsistenciaRequestDto, SearchMotivoInasistenciaRequest, EmpleadoComunidadHistorialDto, UploadEmpleadoAttachResponseDto, EmpleadoDocumento, ValidateAsistenciaComunidad } from '../model';

@Injectable({
  providedIn: 'root'
})

export class EmpleadoService extends CrudService<any, number, any, any> {
  httpCsvOptions = {};

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http, 'empleado', sharedFunctions);
    this.httpCsvOptions = 
    {
      headers: new HttpHeaders(
        { 'Content-type': 'text/csv' }
      ), responseType: 'blob'
    };
  }

  getEmpleadoComunidad(): Observable<GenericResponse<Comunidad[]>> {
    return this._http.get<GenericResponse<Comunidad[]>>(this._serviceUrl + '/empleado-comunidad', this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadEmpleadoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadEmpleadoAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  getAttachments(id: number): Observable<GenericResponse<EmpleadoDocumento[]>> {
    return this._http.get<GenericResponse<EmpleadoDocumento[]>>(this._serviceUrl + '/' + id + '/documentos', this.httpOptions);
  }

  getEmpleadoAsistencia(value: any): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/empleado-asistencia' + queryString, this.httpOptions);
  }

  getSearchAsistenciaUrl(): string {
    return this._serviceUrl + "/reporte-search-asistencia";
  }

  getSearchAsistencia(value: SearchEmpleadoAsistenciaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/search-asistencia' + queryString, this.httpOptions);
  }

  saveAsistencias(asistenciasMarcadas: any[]): Observable<any> {
    return this._http.post<any[]>(this._serviceUrl + '/registrar-asistencia', asistenciasMarcadas, this.httpOptions);
  }

  exportAsistencias(value: SearchEmpleadoAsistenciaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-search-asistencia' + queryString, this.httpCsvOptions);
  }

  exportAsistenciasSelected(r:SearchEmpleadoAsistenciaExport): Observable<any> {    
    let HTTPOptions:Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'text'
    }

    return this._http.post<any>(this._serviceUrl + '/export-selected-asistencia',r, HTTPOptions);
  }

  getSearchUrl() {
    return this._serviceUrl + '/search';
  }

  getTipoAsistencia(): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/tipos', this.httpOptions);
  }

  validateAsistenciaComunidad(r: ValidateAsistenciaComunidad): Observable<any>{
    return this._http.post<any>(this._serviceUrl + '/validate-asistencia-obra', r, this.httpOptions);
  }
}